<div class="d-flex align-items-center p-2" *ngIf="loading">
    <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
    <span class="ml-2">Please wait while loading Package Details ...</span>
</div>
<div class="package-charges-loading" *ngIf="loadingCharges">
    <div class="d-flex align-items-center bg-white p-2">
        <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
        <span class="ml-2">Please wait while loading Charges ...</span>
    </div>
</div>
<div class="mh-400 p-2 position-relative" *ngIf="!loading && !packageInfo">
    <no-data [title]="'Package Details'"></no-data>
</div>
<div class="row" *ngIf="!loading && packageInfo">
    <div class="col-12">
        <h5 class="card-header p-2 bg-light heading2 d-flex justify-content-between align-items-center" [class.border-radius-none]="!isCounselling" [class.bgr]="isCounselling">
            <div>
                <div class="font-16 mb-1">
                    <span *ngIf="!packageInfo.packageModule?.packageName" [textContent]="'Package Preview'"></span>
                    <ng-container *ngIf="packageInfo.packageModule?.packageName">
                        <span [class.text-primary]="!isCounselling" [textContent]="packageInfo.packageModule?.packageName"></span>
                        <ng-container *ngIf="packageInfo.packageModule?.moduleTypeId && packageInfo.packageModule?.packageTypeId">
                            <span class="ml-1 font-13" [class.text-mute]="!isCounselling" [textContent]="'(' + packageInfo.packageModule.moduleTypeName + ' / '"></span>
                            <span class="font-13" [class.text-mute]="!isCounselling" [textContent]="packageInfo.packageModule.packageTypeName + ')'"></span>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="font-13">
                    <span [textContent]="packageInfo.packageModule.locationName"></span>
                    <small class="text-mute ml-1" [textContent]="'(' + packageInfo.packageModule.templateName + ')'"></small>
                </div>
            </div>
            <div class="text-mute font-weight-normal font-13 d-flex flex-column">
                <div class="mb-1" *ngIf="packageInfo.packageModule?.providerName">
                    <span class="text-dark" style="width: 70px; display: inline-block;">Doctor</span>
                    <span>
                        <span [textContent]="packageInfo.packageModule.providerName"></span>
                        <small class="ml-1" [textContent]="'(' + packageInfo.packageModule.departmentName + ')'"></small>
                    </span>
                </div>
                <div *ngIf="packageInfo.packageModule?.expiresIn">
                    <span class="text-dark" style="width: 70px; display: inline-block;">Expires in</span>
                    <span>
                        <span [textContent]="packageInfo.packageModule.expiresIn"></span>
                        <span class="ml-1" [textContent]="'days'"></span>
                    </span>
                </div>
            </div>
        </h5>
        <div class="pt-2" [class.px-2]="!isCounselling" [class.px-0]="!isCounselling">
            <div *ngIf="!chargeCategory" class="mb-2">
                <div class="d-flex align-items-center" *ngIf="loadingChargeCategories">
                    <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
                    <span class="ml-2">Please wait while loading Package Cost Details ...</span>
                </div>
                <ng-container *ngIf="!loadingChargeCategories && chargeCategories?.length">
                    <label class="mb-1 font-13 font-weight-bold text-primary font-13">Charge Categories</label>
                    <div class="package-details-container">
                        <table class="table table-centered table-light-border mb-0 font-13">
                            <thead class="thead-no-bdr">
                                <tr>
                                    <th>Charge Category</th>
                                    <th style="width: 180px" class="text-right">Sub Total</th>
                                    <th style="width: 180px" class="text-right">Discount</th>
                                    <th style="width: 180px" class="text-right">Total</th>
                                    <th class="text-right"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="h-32" *ngFor="let item of chargeCategories; let i = index;">
                                    <td style="width: 40%" class="pl-0 font-weight-semibold" [class.border-0]="i === 0">
                                        <span [textContent]="item.name"></span>
                                    </td>
                                    <td class="text-right" [class.border-0]="i === 0">
                                        <span [textContent]="item.subTotal | currency :'₹ ':'symbol':'1.2-2'"></span>
                                    </td>
                                    <td class="text-right" [class.border-0]="i === 0">
                                        <span [textContent]="item.discount | currency :'₹ ':'symbol':'1.2-2'"></span>
                                    </td>
                                    <td class="text-right" [class.border-0]="i === 0">
                                        <span [textContent]="item.total | currency :'₹ ':'symbol':'1.2-2'"></span>
                                    </td>
                                    <td [class.border-0]="i === 0" style="width: 50px" class="text-right pr-0">
                                        <a class="text-primary cursor-pointer" (click)="onSelectChargeCategory(item.id)"><i class="fe-eye"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>
            </div>
            <div class="mb-1 w-100 font-13 d-flex align-items-end justify-content-between" *ngIf="!isCounselling">
                <label class="font-weight-bold mb-0 text-primary">Package Details</label>
                <div class="d-flex align-items-center" *ngIf="chargeCategory">
                    <span class="text-muted mr-1">Charge Category : </span>
                    <ng-select class="ng-select-28px" [items]="chargeCategories" [loading]="loadingChargeCategories" [clearable]="true" bindLabel="name" placeholder="Select Charge Category" [(ngModel)]="chargeCategory" (change)="onSelectChargeCategory($event.id)" (clear)="onClearChargeCategory();">
                        <ng-template ng-option-tmp let-item="item">
                            <span class="font-weight-semibold font-11" [textContent]="item.name"></span>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="font-weight-semibold font-11" [textContent]="item.name"></span>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="mb-1 w-100 font-13 d-flex align-items-end justify-content-between" *ngIf="isCounselling">
                <label class="font-weight-bold mb-0"> &nbsp; &nbsp;Inclusions</label>
                <div *ngIf="!hidePrice" class="form-check form-check-primary">
                    <input class="form-check-input rounded-circle" [(ngModel)]="hidePrices" type="checkbox" id="chkHidePrices">
                    <label class="form-check-label" for="chkHidePrices">Hide Prices</label>
                </div>
            </div>
            <div class="package-details-container" [class.mb-2]="!isCounselling" *ngIf="packageInfo.modules?.length">
                <div class="package-details-section" *ngFor="let md of packageInfo.modules;">
                    <span class="package-module-title" [textContent]="md.moduleName"></span>
                    <table class="table table-centered table-light-border mb-0">
                        <tbody>
                            <tr [class.strike-item]="item.isNA" [class.d-none]="item.isNA" *ngFor="let item of fetchPackageDetails(md.modulesMasterId);">
                                <td style="width: 30px" [textContent]="item.quantity"></td>
                                <td *ngIf="md.isChargeCategoryApplicable || md.isPackageApplicable" [textContent]="item.chargeName || '-'"></td>
                                <td *ngIf="!md.isChargeCategoryApplicable && !md.isPackageApplicable && md.packageType === packageType.Limit" [textContent]="md.moduleName + ' Amount'"></td>
                                <td *ngIf="!md.isChargeCategoryApplicable && !md.isPackageApplicable && md.packageType === packageType.Quantity" [textContent]="'No.of ' + md.moduleName"></td>
                                <td style="width: 90px" *ngIf="item.repeatTypeName && md.isChargeCategoryApplicable || md.isPackageApplicable ">
                                    <small [textContent]="item.repeatTypeName" class="text-muted"></small>
                                </td>
                                <td class="text-right" style="width: 135px" *ngIf="!hidePrices">
                                    <span *ngIf="!item.isFree && chargeCategory" [textContent]="(item.amount || 0) | currency :'₹ ':'symbol':'1.2-2'"></span>
                                    <small *ngIf="item.isFree">Free <span class="font-10 text-muted" *ngIf="chargeCategory" [textContent]="'(' + ((item.amount || 0) | currency :'₹ ':'symbol':'1.2-2') + ')'"></span></small>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table class="table table-centered table-responsive mb-0 mt-2 table-borderless font-13">
                    <tbody>
                        <tr class="h-32 col-12">
                            <td style="width: 135px" class="pl-0 pb-0 font-weight-bold">Exclusions</td>
                            <td  class="pb-0">
                                <span class="mb-0 break-all" *ngIf="packageInfo.packageModule?.exclusions" [textContent]="packageInfo.packageModule.exclusions"></span>
                                <span *ngIf="!packageInfo.packageModule?.exclusions" class="text-muted">Not recorded.</span>
                            </td>
                        </tr>
                        <tr  class="h-32 col-12">
                            <td class="pl-0 font-weight-bold">Package Notes</td>
                            <td>
                                <span class="mb-0 break-all" *ngIf="packageInfo.packageModule?.notes" [textContent]="packageInfo.packageModule.notes"></span>
                                <span *ngIf="!packageInfo.packageModule?.notes" class="text-muted">Not recorded.</span>
                            </td>
                        </tr>
                        <tr class="h-32 col-12">
                            <td class="pl-0 font-weight-bold">Comments</td>
                            <td>
                                <p class="mb-0 pre-line break-all" *ngIf="packageInfo.packageModule?.comments" [textContent]="packageInfo.packageModule.comments"></p>
                                <span *ngIf="!packageInfo.packageModule?.comments" class="text-muted">Not recorded.</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table table-centered package-amounts" *ngIf="!isCounselling">
                    <tbody>
                        <tr>
                            <td class="pb-0">Total Quantity</td>
                            <td class="pb-0" [textContent]="packageInfo.packageModule.quantity"></td>
                        </tr>
                        <tr *ngIf="!chargeCategory">
                            <td class="pb-0">Discount</td>
                            <td class="pb-0" [textContent]="packageInfo.packageModule.discountPercentage ? packageInfo.packageModule.discountPercentage + '%' : ((packageInfo.packageModule.discountAmount || 0) | currency :'₹ ':'symbol':'1.2-2')"></td>
                        </tr>
                        <ng-container *ngIf="chargeCategory">
                            <tr>
                                <td class="pb-0">Sub Total</td>
                                <td class="pb-0" [textContent]="chargeCategory.subTotal | currency :'₹ ':'symbol':'1.2-2'"></td>
                            </tr>
                            <tr class="text-success">
                                <td class="pb-0">Discount</td>
                                <td class="pb-0" [textContent]="chargeCategory.discount | currency :'₹ ':'symbol':'1.2-2'"></td>
                            </tr>
                            <tr class="font-weight-bold font-15">
                                <td class="pb-0">Total</td>
                                <td class="pb-0" [textContent]="chargeCategory.total | currency :'₹ ':'symbol':'1.2-2'"></td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>